import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import DealCard from './DealCard.jsx';
import { cn } from '@/lib/utils.js';

// Kind-of-work section (design-reference/command-center.mockup.html): a
// collapsible header — chevron · severity dot · label · count · summary — over
// the deal cards. Severity drives the heading + dot color: urgent→accent,
// warn→warning, info→muted. NO blue (section severity ≠ the urgency dot, and
// 'info' here is "tracking", rendered muted). Empty sections STAY LISTED —
// absence is information — and render a one-line placeholder.

const SEVERITY_TEXT = { urgent: 'text-accent', warn: 'text-warning', info: 'text-text-muted' };
const SEVERITY_DOT = { urgent: 'bg-accent', warn: 'bg-warning', info: 'bg-text-dim' };

export default function CategorySection({ section }) {
  const [open, setOpen] = useState(true);
  const items = section?.items || [];
  const count = items.length;
  const sev = section?.severity || 'info';

  return (
    <section className="space-y-2">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-baseline gap-2 border-b border-border pb-1.5 text-left"
      >
        <ChevronDown
          size={12}
          strokeWidth={2.5}
          className={cn('shrink-0 self-center text-text-dim transition-transform', !open && '-rotate-90')}
        />
        <span className={cn('h-2 w-2 shrink-0 self-center rounded-full', SEVERITY_DOT[sev] || 'bg-text-dim')} />
        <h2 className={cn('text-xs font-semibold uppercase tracking-[0.14em]', SEVERITY_TEXT[sev] || 'text-text-muted')}>
          {section?.label}
        </h2>
        {section?.summary ? (
          <span className="hidden text-[10px] text-text-dim sm:inline">· {section.summary}</span>
        ) : null}
        <span className={cn('ml-auto font-mono text-[10px]', count > 0 ? (SEVERITY_TEXT[sev] || 'text-text-dim') : 'text-text-dim')}>
          {count}
        </span>
      </button>

      {open ? (
        count === 0 ? (
          <p className="text-xs italic text-text-dim">Nothing pending.</p>
        ) : (
          <div className="space-y-2">
            {items.map((item) => <DealCard key={item.deal_id} item={item} />)}
          </div>
        )
      ) : null}
    </section>
  );
}
